var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback } from "react";
import useLocalState from "../useLocalState";
import { Owner } from "../ChatbotService/ChatbotService";
var useMessages = function () {
    var _a = useLocalState("chat-messages", []), messages = _a[0], setMessages = _a[1];
    var addMessage = useCallback(function (message) {
        setMessages(function (chatLog) {
            var _a;
            if (message.owner === Owner.System &&
                ((_a = chatLog[chatLog.length - 1]) === null || _a === void 0 ? void 0 : _a.owner) === Owner.System) {
                return __spreadArray(__spreadArray([], chatLog.slice(0, -1), true), [message], false);
            }
            return __spreadArray(__spreadArray([], chatLog, true), [message], false);
        });
    }, [setMessages]);
    var resetMessages = useCallback(function () {
        setMessages([]);
    }, [setMessages]);
    var disableMessage = useCallback(function (index, isDisabled) {
        setMessages(function (chatLog) {
            var newMessages = __spreadArray([], chatLog, true);
            newMessages[index].isDisabled = isDisabled;
            return newMessages;
        });
    }, [setMessages]);
    return { messages: messages, addMessage: addMessage, resetMessages: resetMessages, disableMessage: disableMessage };
};
export default useMessages;
